import { get } from "./requests";

export function getDashboardStats() {
  return get("/owner/v1/dashboard/stats").then(res => res.json());
}

export function getSubscriptionInfo() {
  return get("/owner/v1/subscription").then(res => res.json());
}
